import { Routes } from './routes';

export * from './routes';
export * from './directRoute';
export * from './authorizedRoute';
export * from './publicRoute';

export default Routes;